import React from "react"
import PropTypes from "prop-types"

const PrintIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 18 16">
    <path d="m13.9370323 13.4193548h1.4508387v-1.4508387h-1.4508387zm-8.71122585 6.0975484h7.54838705v-3.4838709h-7.54838705zm0-10.16206449h7.54838705v-2.90322581h-7.54838705zm-1.45083871 11.61290319h10.45161286v-6.3870967h-10.45161286zm14.22503226-9.7254193v5.8064516c0 1.0436129-.843871 1.8874839-1.8874839 1.8874839h-.7246451v-1.4523871h.7246451c.2369033 0 .4366452-.199742.4366452-.4350968v-5.8064516c0-.2369032-.1997419-.4350968-.4366452-.4350968h-14.22503223c-.23690322 0-.43664516.1981936-.43664516.4350968v5.8064516c0 .2353548.19974194.4350968.43664516.4350968h.72464516v1.4523871h-.72464516c-1.0436129 0-1.88748387-.843871-1.88748387-1.8874839v-5.8064516c0-1.0436129.84387097-1.88748389 1.88748387-1.88748389h1.88748387v-4.3556129h10.45161286v4.3556129h1.8859355c1.0436129 0 1.8874839.84387099 1.8874839 1.88748389z" fillRule="evenodd" transform="translate(0 -5)" />
  </svg>
)

PrintIcon.propTypes = {
  style: PropTypes.object
}

export default PrintIcon



// WEBPACK FOOTER //
// ./src/components/icons/print-icon.jsx